import React from 'react';

import { for_you_path } from '@routes';

import { FOR_YOU } from './constants';

interface BookmarkAddedToastProps {
  onToastClick: () => void;
}

const BookmarkAddedToast = ({ onToastClick }: BookmarkAddedToastProps) => (
  <>
    Article saved. View all bookmarks at{' '}
    <a href={for_you_path()} onClickCapture={onToastClick}>
      {FOR_YOU}
    </a>
  </>
);

export default BookmarkAddedToast;
